import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  { path: '/login', component: () => import('@/views/LoginView.vue') },
  { path: '/', component: () => import('@/views/HomeView.vue') },
  { path: '/pools/:poolId/prepare', component: () => import('@/views/PrepareView.vue') },
  { path: '/pools/:poolId/purchase', component: () => import('@/views/PurchaseView.vue') },
  { path: '/pools/:poolId/booking-overview', component: () => import('@/views/BookingOverviewView.vue'), meta: { admin: true } },
  { path: '/account', component: () => import('@/views/AccountView.vue') },
  { path: '/admin/users', component: () => import('@/views/admin/UsersAdminView.vue'), meta: { admin: true } },
  { path: '/admin/pools', component: () => import('@/views/admin/PoolsAdminView.vue'), meta: { admin: true } },
  { path: '/pools/:poolId/tickets', component: () => import('@/views/TicketImportView.vue'), meta: { admin: true } },
  { path: '/pools/:poolId/my-tickets', component: () => import('@/views/MyTicketsView.vue') },
  { path: '/share/:shareToken', component: () => import('@/views/ShareView.vue'), meta: { public: true } },
  { path: '/:pathMatch(.*)*', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Public routes (meta.public) and /login bypass the auth check entirely.
// All other routes require a valid session; unauthenticated visitors are
// sent to /login with a redirect param so they land on the right page after login.
router.beforeEach(async (to) => {
  if (to.path === '/login' || to.meta.public) return true

  const auth = useAuthStore()
  await auth.ensureInitialized()

  if (!auth.isLoggedIn) {
    const redirect = to.fullPath !== '/' ? to.fullPath : undefined
    return { path: '/login', query: redirect ? { redirect } : {} }
  }

  if (to.meta.admin && !auth.isAdmin) {
    return '/'
  }
})

export default router
